<template>
  <div>
    <h3>Request</h3>
    <section>
      <div class="form-inline" v-if="!isAnonymous">
        <label>Tech Name:</label>
        <div>
          <input type="text" disabled v-model="techName" />
        </div>
      </div>
      <div class="form-inline" v-if="isAnonymous">
        <label>Tech Bio:</label>
        <div>
          <textarea rows="3" disabled v-model="techBio" />
        </div>
      </div>
      <div class="form-inline">
        <label>Your Email:</label>
        <div>
          <input type="text" placeholder="Your Email" v-model="clientEmail" />
        </div>
      </div>
      <div class="form-inline">
        <label>Tell us what kind of job you want the tech to perform?</label>
        <div>
          <textarea rows="3" placeholder="Request" v-model="editRequest" />
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
        >Request</spinnerButton>
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading", "propsData"],
  data() {
    return {
      techName: null,
      techEmail: null,
      clientEmail: null,
      editRequest: null,
      isAnonymous: true,
      techBio: null
    };
  },
  components: {
    spinnerButton
  },
  watch: {
    propsData: function() {
      this.initData();
    }
  },
  mounted: function() {
    this.initData();
  },
  methods: {
    initData: function() {
      this.submitLoading = false;
      this.techName = this.propsData.techName ? this.propsData.techName : null;
      this.techEmail = this.propsData.techEmail
        ? this.propsData.techEmail
        : null;
      this.clientEmail = this.propsData.clientEmail
        ? this.propsData.clientEmail
        : null;
      this.editRequest = null;
      this.techBio = this.propsData.techBio ? this.propsData.techBio : null;
      this.isAnonymous = this.propsData.isAnonymous;
    },
    buttonClick: function() {
      const data = {
        techName: this.techName,
        techEmail: this.techEmail,
        clientEmail: this.clientEmail,
        request: this.editRequest
      };
      this.$emit("buttonClick", data);
    }
  }
};
</script>